import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import "./Skeleton.css";
export default function Skeleton({ children, width, height, margin, loading = true }) {
    if (!loading) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx("div", { className: "skeleton", style: { width: width, height: height, margin: margin }, children: children }));
}
